import { render, staticRenderFns } from "./PanelCompetitionResultsLiveAll.vue?vue&type=template&id=9981aaa2&scoped=true&"
import script from "./PanelCompetitionResultsLiveAll.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionResultsLiveAll.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionResultsLiveAll.vue?vue&type=style&index=0&id=9981aaa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9981aaa2",
  null
  
)

export default component.exports